import React from "react";
import { Icon } from "../icon/Icon";
import { getId } from "~assets/frontend/_util/getId";
export const GenericTextButton = ({ label, className, onClick, disabled = false, children, childrenBefore }) => {
    return (React.createElement("button", { disabled: disabled, className: className, onClick: onClick },
        childrenBefore,
        React.createElement("span", null, label),
        children));
};
export const TextButton = ({ label, className, icon, onClick, disabled = false }) => {
    let iconStart, iconEnd = undefined;
    if (icon !== undefined) {
        const iconClassName = 
        /* default       */ "before:bg-black-100 before:transition-colors " +
            /* hover         */ "group-enabled/TextButton:group-hover/TextButton:before:bg-red-100 group-enabled/TextButton:group-focus/TextButton:before:bg-red-100 " +
            /* disabled      */ "group-disabled/TextButton:before:bg-black-40 " +
            /* active        */ "" +
            /* dark          */ "dark:before:bg-white " +
            /* dark hover    */ "dark:group-enabled/TextButton:group-hover/TextButton:before:bg-white dark:group-enabled/TextButton:group-focus/TextButton:before:bg-white " +
            /* dark disabled */ "" +
            /* dark active   */ "";
        if (icon.position == "start") {
            iconStart = React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: icon.identifier, className: "mr-6 " + iconClassName });
        }
        if (icon.position == "end") {
            iconEnd = React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: icon.identifier, className: "ml-6 " + iconClassName });
        }
    }
    return (React.createElement(GenericTextButton, { className: 
        /* default       */ "group/TextButton group inline-flex items-center underline-offset-[4px] transition-colors " +
            /* hover         */ "enabled:hocus:text-red-100 " +
            /* disabled      */ "disabled:text-black-40 " +
            /* active        */ "enabled:active:underline " +
            /* dark          */ "dark:text-white " +
            /* dark hover    */ "dark:enabled:hocus:text-white dark:enabled:hocus:underline " +
            /* dark disabled */ "dark:disabled:text-black-40 " +
            /* dark active   */ "" +
            (className ? className : ""), label: label, disabled: disabled, onClick: onClick, childrenBefore: iconStart, children: iconEnd }));
};
